import getMenuMatchKeys from './getMenuMatchKeys';
import urlToList from './urlToList';

const getSelectedMenuKeys = (flatMenuKeys, pathname) =>
  getMenuMatchKeys(flatMenuKeys, urlToList(pathname));

export default getSelectedMenuKeys;
